// eslint-disable-next-line import/prefer-default-export
import React from 'react';
import shortid from 'shortid';
import ParagraphWithHeading from '../components/ParagraphWithHeading';

export const correctOrphanWordInSentence = (sentence = '') => sentence.replace(/\s(?=[^\s]*$)/, '\u00A0');

export const createParagraphs = (contentArray) => (
  contentArray.map((paragraphItem) => {
    if (paragraphItem.list) {
      return (
        <div className="paragraphTextWrapper" key={shortid.generate()}>
          <ul className="paragraphBody">
            {
              paragraphItem.list.map((item) => (
                <li key={shortid.generate()}>{item}</li>
              ))
            }
          </ul>
        </div>
      );
    }
    return (
      <ParagraphWithHeading
        key={shortid.generate()}
        heading={paragraphItem.title}
        body={paragraphItem.content}
      />
    );
  })
);
